angular.module('core')
  .service('gradeApi', ['$http', '$filter', 'gradeFilter', 'highlightsApi', 'transformResponse', '$timeout', 'cancelableResourceFactory', 'cancelableResourceManager', '$state', 'timeframe', 'exportService', function($http, $filter, $gradeFilter, $highlightsApi, $transformResponse, $timeout, $cancelableResourceFactory, $cancelableResourceManager, $state, $timeframe, $exportService) {
    var self = this;

    var gradeNavigationMapping = function(grade) {
      grade.name = $gradeFilter(grade.id);
    };

    var gradeReportingMapping = function(grade) {
      grade.name = $gradeFilter(grade.id);
      grade.averageMonthlySessionTime = grade.average_monthly_session_time;
      grade.extendedUsage = grade.percent_usage_extended_hours;
      grade.averageGrowth = grade.percent_growth;
    };

    var GradeNavigation = $cancelableResourceFactory.createCacheableResource('GradeNavigation', '/n/districts/:districtId/grades', {id: '@id'}, {
      query: {
        cache: true,
        url: '/n/districts/:districtId/grades',
        method: 'GET',
        isArray: true,
        transformResponse: function(body) {
          return $transformResponse.transformNavigationQuery('grade', body, gradeNavigationMapping);
        }
      },

      get: {
        cache: true,
        url: '/n/districts/:districtId/grades?grade_id=:grade_id',
        method: 'GET',
        isArray: false,
        transformResponse: function(body) {
          return $transformResponse.transformNavigationGet('grade', body, gradeNavigationMapping);
        }
      }
    });

    var gradeReportingUrl = '/r/districts/:districtId/overview';

    // Calling with different timeframes returned wrong data when cache:true was set.  Maybe
    // an issue with the cache key / default params.
    var GradeReporting = $cancelableResourceFactory.createCacheableResource('GradeReporting', '/r/districts/:districtId/overview', {id: '@id'}, {
        query: {
          url: gradeReportingUrl,
          cache: false,  // true setting here caused district/grades page list table to show values from previous request
          method: 'GET',
          isArray: true,
          transformResponse: function(body, headersGetter, status) {
            return $transformResponse.transformReportingQuery('grade', body, gradeReportingMapping, status);
          }
        }
    });

    /**************************************************************/
    /*                          Api                               */
    /**************************************************************/

    var getGradesReportingParams = function() {
      var params = _.pick($state.params, ['districtId']);
      params.school_id = $state.params.schoolId || undefined;
      params.sy = $timeframe.getSchoolYear();
      params.fd = $timeframe.getFromDate();
      params.td = $timeframe.getToDate();
      return params;
    };

    self.getGradesReportingExportUrl = function() {
      var params = getGradesReportingParams();
      return $exportService.buildExportUrl(gradeReportingUrl, params);
    };

    self.getGradesReporting = function() {
      var params = getGradesReportingParams();
      var promises = GradeReporting.query(params);
      $cancelableResourceManager.addAndRemoveOnFinish(promises);

      return promises.$promise;
    };

    self.getGrades = function(callback) {
      var params = _.pick($state.params, ['districtId']);
      params.school_id = $state.params.schoolId || undefined;

      var promises = GradeNavigation.query(params);
      promises.$promise.then(callback);
      return promises;
    };

    self.getGrade = function(grade_id, callback) {
      var params = _.pick($state.params, ['districtId']);
      params.grade_id = grade_id;
      params.school_id = $state.params.schoolId || undefined;

      var promises = GradeNavigation.get(params);
      promises.$promise.then(callback);
      return promises;
    };

    self.getGradeData = function(grade_id, callback) {
      var params = _.pick($state.params, ['districtId']);
      params.grade_id = grade_id;
      params.school_id = $state.params.schoolId || undefined;
      params.sy = $timeframe.calculateCurrentReportingYear();

      var promises = $highlightsApi.GradeHighlights.get(params);
      promises.$promise.then(callback);
      return promises;
    };

  }]);
